import {BinIcon} from "../../../../../../components/icon/Icon.jsx";
import {OnEquityBadgeStyled} from "./styled/OnEquityBadgeStyled.js";
import { useLangContext } from "../../../../../../providers/LangProvider/LangProviderContext.js";

function OnEquityBadge() {
    const {getLangPath} = useLangContext();

    return <OnEquityBadgeStyled>
        <BinIcon name="IcCheckMarkCircle" style={{fill: 'var(--color-base)'}}/>
        <span className="ms-1">{getLangPath('bonuses.on_equity')}</span>
    </OnEquityBadgeStyled>
}

export default OnEquityBadge;
